export default function (state = [], action) {
    switch (action.type) {
        case "ASKED_TEMPLATE_ACTIVATION_SELECTED":
            return action.payload;
        default:
            return state;
    }
}